const EMAIL_PUBLIC_RSA_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDL0bn59V0XP6gfLZSudymp1o3L
5t5tNNJNgzzSmuqYjVV48FK2ofQsSp3idXB+djySq51UABozutwIRQiiltaP/X3u
TjJEuuYGn2L7nGRnn/HPWAa+OScm4FkNLgqKGfPNz+6vSW8Ab0XYZBNLLsTy+ulP
jnn6iRdveAo2LRZ64wIDAQAB
-----END PUBLIC KEY-----`;

export { EMAIL_PUBLIC_RSA_KEY };
